"use client";

import { getSessionData } from "@repo/shared-utils/common-utils";
import { LeadStatus, selectIsAuthSuccessOrPerpetual, setLeadStatus, useAppDispatch, useAppSelector } from "@repo/web-store";
import { useEffect } from "react";


const LeadsApiWrapper = () => {
    const isAuthSuccessOrPerpetual = useAppSelector(selectIsAuthSuccessOrPerpetual);
    const appDispatch = useAppDispatch();

    useEffect(() => {
        const updateLeadStatus = async () => {
            const { leadsBuySell } = await import("@repo/sso/leadsApi");
            const { mobileNo } = await getSessionData();
            if (!mobileNo) return;
            const leadsData = await leadsBuySell(mobileNo);
            appDispatch(
                setLeadStatus({
                    leadStatus: (leadsData?.statusCode === 90 ? leadsData.data?.flag : "") as LeadStatus,
                })
            );
        };

        const timer = setTimeout(() => {
            updateLeadStatus();
        }, 500);

        return () => clearTimeout(timer);
    }, [isAuthSuccessOrPerpetual, appDispatch]);

    return <></>
}

export default LeadsApiWrapper

